import axios from '../axios';
// 客户月销售统计
export const getPartnerOrderInvoiceList = data => {
    return axios({
        url: '/api/sys/fin/getPartnerOrderInvoiceList',
        method: 'post',
        data
    })
};
// 查询客户返利
export const getPartnerRebate = data => {
  return axios({
      url: '/api/sys/fin/getPartnerRebate',
      method: 'post',
      data
  })
};
// 查询客户返利后传入结转表
export const saveFinSettle = data => {
  return axios({
      url: '/api/sys/fin/saveFinSettle',
      method: 'post',
      data
  })
};
// 财务结算
export const updateFinSettleRebate = data => {
  return axios({
      url: '/api/sys/fin/updateFinSettleRebate',
      method: 'post',
      data
  })
};
// 单位月结转列表
export const getFinSettlePage = data => {
  return axios({
      url: '/api/sys/fin/getFinSettlePage',
      method: 'post',
      data
  })
};
// 客户确认
export const auditSettle = data => {
  return axios({
      url: '/api/sys/fin/auditSettle',
      method: 'post',
      data
  })
};
// 不参与返利
export const unJoinRebate = data => {
  return axios({
      url: '/api/sys/fin/unJoinRebate',
      method: 'post',
      data
  })
};
// 是否参与返利
export const updateRebateEntryByTMark = data => {
  return axios({
      url: '/api/sys/stk/updateRebateEntryByTMark',
      method: 'post',
      data
  })
};
// 单位月结转明细列表
export const getFinSettleEntryPage = data => {
  return axios({
      url: '/api/sys/fin/getFinSettleEntryPage',
      method: 'post',
      data
  })
};
// 客户返利统计
export const getPartnerRebateSumList = data => {
  return axios({
      url: '/api/sys/fin/getPartnerRebateSumList',
      method: 'post',
      data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/CarryFor.js